import {z} from "zod/v4-mini"
import {remotelyColorLike} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"

export const sourceType = z.union([anyImageOpResult, remotelyColorLike])

export type SourceType = z.infer<typeof sourceType>
